import React from 'react';
import { ArrowRight, CheckCircle2, XCircle, ShieldCheck, Star } from 'lucide-react';
import { SocialProofPopup } from '../components/SocialProofPopup';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/nePCbVw6Cy9vThktsAL78S/yCFDcnonFW3vhrB5Kza4r-removebg-preview.png';
const CHECKOUT_URL = 'HTTPS://checkout.ebookpoint.shop/cart/59376750461009:1';
export function LandingPage() {
  const scrollToCheckout = (e: React.MouseEvent) => {
    e.preventDefault();
    const element = document.getElementById('checkout-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-white font-sans text-gray-800 selection:bg-orange-200" data-id="element-10">
      {/* Hero Section */}
      <header className="bg-gray-900 text-white pt-16 pb-12 px-4 text-center" data-id="element-11">
        <div className="max-w-4xl mx-auto" data-id="element-12">
          <h1 className="text-3xl md:text-5xl font-extrabold leading-tight mb-6 text-orange-400" data-id="element-13">
            🏃‍♂️ Un sistema que te permite empezar a correr desde cero
          </h1>

          <img src={PRODUCT_IMAGE} alt="Running para la Vida Real" className="w-full max-w-xs md:max-w-sm mx-auto rounded-xl shadow-2xl cursor-pointer hover:scale-[1.02] transition-transform duration-300 mb-8" onClick={scrollToCheckout} data-id="element-14" />

          <p className="text-xl md:text-2xl font-medium mb-8 text-gray-200" data-id="element-15">
            sin frustrarte… sin lesionarte… y sin abandonar a la semana
          </p>

          <div className="flex items-center justify-center gap-2 mb-8 text-yellow-400 font-bold text-lg bg-gray-800/50 inline-flex px-6 py-3 rounded-full border border-gray-700" data-id="element-16">
            <Star className="w-5 h-5 fill-current" data-id="element-17" />
            <span data-id="element-18">
              4.9/5 Elegido por más de 1.000 personas que dejaron el
              sedentarismo
            </span>
          </div>

          <p className="text-lg md:text-xl mb-10 text-gray-300 max-w-2xl mx-auto" data-id="element-19">
            El sistema más simple, realista y sostenible para empezar a correr
            desde cero
          </p>

          <button onClick={scrollToCheckout} className="w-full md:w-auto bg-orange-500 hover:bg-orange-600 text-white font-bold py-4 px-8 rounded-full shadow-lg shadow-orange-500/30 transform transition hover:-translate-y-1 flex items-center justify-center gap-2 mx-auto text-lg md:text-xl animate-pulse" data-id="element-20">
            👉 Empezar ahora con Running para la Vida Real
          </button>
        </div>
      </header>

      {/* Stats Bar */}
      <div className="bg-orange-500 text-white py-8 px-4" data-id="element-21">
        <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x divide-orange-400/30" data-id="element-22">
          <div className="px-2" data-id="element-23">
            <p className="text-3xl md:text-4xl font-black mb-1" data-id="element-24">+1.000</p>
            <p className="text-sm md:text-base font-medium text-orange-100" data-id="element-25">
              Personas ya empezaron el proceso
            </p>
          </div>
          <div className="px-2" data-id="element-26">
            <p className="text-3xl md:text-4xl font-black mb-1" data-id="element-27">4.9/5</p>
            <p className="text-sm md:text-base font-medium text-orange-100" data-id="element-28">
              Valoración promedio
            </p>
          </div>
          <div className="px-2" data-id="element-29">
            <p className="text-3xl md:text-4xl font-black mb-1" data-id="element-30">+120</p>
            <p className="text-sm md:text-base font-medium text-orange-100" data-id="element-31">
              Recursos prácticos y progresiones guiadas
            </p>
          </div>
          <div className="px-2" data-id="element-32">
            <p className="text-3xl md:text-4xl font-black mb-1" data-id="element-33">#1</p>
            <p className="text-sm md:text-base font-medium text-orange-100" data-id="element-34">
              Sistema para sedentarios que quieren empezar en serio
            </p>
          </div>
        </div>
      </div>

      <main className="max-w-3xl mx-auto px-5 py-16 text-lg md:text-xl leading-relaxed" data-id="element-35">
        {/* Target Audience */}
        <div className="mb-16" data-id="element-36">
          <h2 className="text-2xl md:text-3xl font-bold mb-8 text-gray-900 text-center" data-id="element-37">
            Funciona en la vida real (no en teoría)
          </h2>
          <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-200" data-id="element-38">
            <ul className="space-y-4" data-id="element-39">
              {['Personas sin experiencia', 'Gente con poco tiempo', 'Personas que abandonaron mil veces', 'Adultos que quieren volver a moverse', 'Personas que se cansan rápido o se frustran fácil'].map((item, i) => <li key={i} className="flex items-center gap-3 font-medium text-gray-800" data-id="element-40">
                  <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-41" />
                  <span data-id="element-42">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Pain Points */}
        <div className="mb-16" data-id="element-43">
          <h2 className="text-2xl md:text-3xl font-bold mb-8 text-gray-900 text-center" data-id="element-44">
            ¿Te pasa alguna de estas situaciones?
          </h2>
          <ul className="space-y-4" data-id="element-45">
            {['Intentás empezar a correr… pero abandonás a los pocos días', 'Te cansás demasiado rápido y te frustrás', 'No sabés cuánto correr, cuánto descansar o cómo progresar', 'Sentís que "no es para vos"', 'Te falta constancia y terminás postergando', 'Tenés miedo de lesionarte o hacer las cosas mal'].map((item, i) => <li key={i} className="flex items-start gap-3 bg-red-50 p-4 rounded-xl border border-red-100" data-id="element-46">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-47" />
                <span className="text-red-900 font-medium" data-id="element-48">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Benefits */}
        <div className="mb-16" data-id="element-49">
          <h2 className="text-2xl md:text-3xl font-bold mb-8 text-gray-900 text-center" data-id="element-50">
            Con Running para la Vida Real vas a poder:
          </h2>
          <ul className="space-y-4" data-id="element-51">
            {['Empezar a correr desde cero sin sentirte destruido', 'Construir constancia real (sin depender de motivación)', 'Seguir un sistema claro, simple y progresivo', 'Evitar el abandono típico de las primeras semanas', 'Sentirte mejor física y mentalmente desde el inicio'].map((item, i) => <li key={i} className="flex items-start gap-3 bg-green-50 p-4 rounded-xl border border-green-100" data-id="element-52">
                <CheckCircle2 className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-53" />
                <span className="text-green-900 font-medium" data-id="element-54">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Transition Statement */}
        <div className="bg-gray-900 text-white p-8 md:p-10 rounded-3xl mb-16 text-center shadow-xl" data-id="element-55">
          <p className="mb-6 text-xl md:text-2xl font-medium text-gray-300" data-id="element-56">
            Este sistema fue creado para resolver exactamente esto:
          </p>
          <p className="mb-4 text-2xl md:text-3xl font-bold text-orange-400" data-id="element-57">
            No es falta de ganas.
          </p>
          <p className="text-2xl md:text-3xl font-bold" data-id="element-58">
            Es falta de un método adaptado a tu realidad.
          </p>
        </div>

        {/* Modules Section */}
        <div className="mb-16" data-id="element-59">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4 text-center text-gray-900" data-id="element-60">
            ¿Qué incluye Running para la Vida Real?
          </h2>
          <p className="text-center text-gray-600 mb-10 font-medium" data-id="element-61">
            8 módulos diseñados para transformar sedentarios en personas activas
          </p>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-62">
            {[{
            icon: '🧠',
            title: 'Módulo 1',
            subtitle: 'Mentalidad y Punto de Partida Real',
            desc: 'Entendé cómo empezar desde tu nivel actual sin compararte ni frustrarte.'
          }, {
            icon: '📋',
            title: 'Módulo 2',
            subtitle: 'Sistema de Inicio Progresivo',
            desc: 'Primeras semanas estructuradas paso a paso para evitar agotamiento y abandono.'
          }, {
            icon: '⏱',
            title: 'Módulo 3',
            subtitle: 'Planificación Simple y Sostenible',
            desc: 'Cómo organizar tus sesiones sin complicarte ni perder constancia.'
          }, {
            icon: '📊',
            title: 'Módulo 4',
            subtitle: 'Seguimiento y Progreso Real',
            desc: 'Aprendé a medir avances sin obsesionarte ni frustrarte.'
          }, {
            icon: '⚠️',
            title: 'Módulo 5',
            subtitle: 'Prevención de Lesiones y Errores Comunes',
            desc: 'Evitá los errores que hacen que el 90% abandone.'
          }, {
            icon: '🎯',
            title: 'Módulo 6',
            subtitle: 'Adaptación del Cuerpo al Running',
            desc: 'Cómo hacer que tu cuerpo se acostumbre sin sufrir.'
          }, {
            icon: '🔁',
            title: 'Módulo 7',
            subtitle: 'Sistema Anti-Abandono',
            desc: 'Estrategias reales para sostener el hábito incluso sin motivación.'
          }, {
            icon: '🧩',
            title: 'Módulo 8',
            subtitle: 'Integración en la Vida Real',
            desc: 'Cómo hacer del running algo que encaje en tu rutina (y no al revés).'
          }].map((mod, i) => <div key={i} className="bg-white p-6 rounded-2xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-63">
                <div className="text-4xl mb-4" data-id="element-64">{mod.icon}</div>
                <h3 className="font-bold text-orange-600 text-lg mb-1" data-id="element-65">
                  {mod.title}
                </h3>
                <h4 className="font-bold text-gray-900 mb-2 leading-tight" data-id="element-66">
                  {mod.subtitle}
                </h4>
                <p className="text-gray-600 text-base" data-id="element-67">{mod.desc}</p>
              </div>)}
          </div>

          <div className="text-center mt-12" data-id="element-68">
            <button onClick={scrollToCheckout} className="w-full md:w-auto bg-gray-900 hover:bg-black text-white font-bold py-4 px-8 rounded-full shadow-lg transform transition hover:-translate-y-1 inline-flex items-center justify-center gap-2 text-lg" data-id="element-69">
              👉 Acceder a los 8 módulos ahora
            </button>
          </div>
        </div>

        {/* Bonuses Section */}
        <div className="bg-gradient-to-br from-orange-50 to-orange-100 border border-orange-200 py-12 px-6 mb-16 -mx-5 md:mx-0 md:rounded-3xl" data-id="element-70">
          <div className="text-center mb-10" data-id="element-71">
            <div className="inline-block bg-red-600 text-white font-bold px-4 py-1 rounded-full text-sm animate-pulse mb-4" data-id="element-72">
              🎁 GRATIS por hoy
            </div>
            <h2 className="text-3xl font-black text-gray-900" data-id="element-73">
              Bonos Exclusivos
            </h2>
          </div>

          <div className="space-y-6 mb-10" data-id="element-74">
            {[{
            icon: '📘',
            title: 'Rutina de fuerza básica para corredores iniciantes',
            desc: 'El complemento perfecto para fortalecer tu cuerpo mientras empezás a correr.'
          }, {
            icon: '⚡',
            title: 'Plan Express (para días sin ganas)',
            desc: 'Qué hacer cuando no tenés motivación pero no querés cortar el proceso.'
          }].map((bono, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-orange-100 flex flex-col md:flex-row gap-4 items-start md:items-center relative overflow-hidden" data-id="element-75">
                <div className="absolute top-0 right-0 bg-green-500 text-white font-bold text-xs px-3 py-1 rounded-bl-lg z-10" data-id="element-76">
                  INCLUIDO
                </div>
                <div className="text-4xl bg-orange-50 p-3 rounded-xl" data-id="element-77">
                  {bono.icon}
                </div>
                <div data-id="element-78">
                  <h3 className="text-xl font-bold mb-1 text-gray-900 pr-16" data-id="element-79">
                    {bono.title}
                  </h3>
                  <p className="text-gray-600 text-base" data-id="element-80">{bono.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="text-center bg-white/60 p-6 rounded-2xl border border-orange-200/50" data-id="element-81">
            <p className="text-gray-500 line-through text-lg mb-1" data-id="element-82">
              Valor total de bonos: $29.990
            </p>
            <p className="text-2xl font-black text-orange-600" data-id="element-83">
              🔥 Hoy incluidos GRATIS
            </p>
          </div>
        </div>

        {/* Testimonials */}
        <div className="mb-16" data-id="element-84">
          <h2 className="text-2xl md:text-3xl font-bold mb-8 text-gray-900 text-center" data-id="element-85">
            Lo que dicen otras personas
          </h2>
          <div className="space-y-4" data-id="element-86">
            {[{
            quote: 'Siempre arrancaba y dejaba. Con esto, por primera vez siento que puedo sostenerlo.',
            author: 'Nicolás, 34 años, Buenos Aires'
          }, {
            quote: 'Antes correr era una tortura. Ahora lo disfruto y no lo sufro.',
            author: 'Carla, 29 años, Córdoba'
          }, {
            quote: 'Lo mejor es que no te exige de más. Te acompaña desde cero real.',
            author: 'Diego, 41 años, Rosario'
          }, {
            quote: 'Pensé que no era para mí… y ahora salgo a correr 3 veces por semana.',
            author: 'Mariana, 37 años, Mendoza'
          }, {
            quote: 'No es motivación. Es estructura. Y eso cambia todo.',
            author: 'Lucas, 32 años, La Plata'
          }].map((t, i) => <div key={i} className="bg-white p-6 rounded-2xl border border-gray-200 shadow-sm" data-id="element-87">
                <div className="flex text-yellow-400 mb-3" data-id="element-88">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-89" />)}
                </div>
                <p className="text-gray-800 font-medium text-lg mb-3" data-id="element-90">
                  "{t.quote}"
                </p>
                <p className="text-gray-500 text-sm" data-id="element-91">— {t.author}</p>
              </div>)}
          </div>
        </div>

        {/* Checkout Section */}
        <div id="checkout-section" className="bg-white border-4 border-orange-500 rounded-3xl p-8 md:p-12 text-center shadow-2xl relative scroll-mt-10 mb-16" data-id="element-92">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-gray-900" data-id="element-93">
            👉 Sí, quiero empezar a correr bien
          </h2>

          <p className="mb-8 text-xl text-gray-600 font-medium" data-id="element-94">
            La opción elegida por personas que quieren dejar de postergar
          </p>

          <div className="bg-gray-50 border border-gray-200 p-6 rounded-2xl mb-8 text-left max-w-sm mx-auto" data-id="element-95">
            <p className="font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-96">
              <span className="text-xl" data-id="element-97">⚡</span> Incluye:
            </p>
            <ul className="space-y-3" data-id="element-98">
              {['Acceso inmediato', 'Acceso de por vida', 'Actualizaciones incluidas', 'Garantía de 7 días'].map((item, i) => <li key={i} className="flex items-center gap-2 text-gray-700 font-medium" data-id="element-99">
                  <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-100" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-gray-100 p-6 rounded-xl mb-8 inline-block mx-auto w-full max-w-sm" data-id="element-101">
            <p className="text-5xl font-black text-green-600 mb-2" data-id="element-102">$19.990</p>
            <p className="text-lg text-gray-500 line-through" data-id="element-103">$47.990</p>
          </div>

          <a href={CHECKOUT_URL} className="block w-full bg-green-500 hover:bg-green-600 text-white font-black py-5 px-8 rounded-2xl shadow-[0_8px_0_rgb(21,128,61)] hover:shadow-[0_4px_0_rgb(21,128,61)] hover:translate-y-1 transition-all text-xl md:text-2xl mb-6" data-id="element-104">
            👉 Empezar ahora con Running para la Vida Real
          </a>

          <div className="flex items-center justify-center gap-2 text-gray-500 text-sm font-medium" data-id="element-105">
            <ShieldCheck className="w-5 h-5 text-green-500" data-id="element-106" />
            <span data-id="element-107">Pago 100% seguro y encriptado</span>
          </div>
        </div>

        {/* Closing Section */}
        <div className="text-center bg-gray-900 text-white p-10 md:p-16 rounded-3xl shadow-2xl" data-id="element-108">
          <p className="mb-6 text-xl text-gray-300" data-id="element-109">Si estás leyendo esto…</p>
          <p className="mb-6 text-2xl font-bold" data-id="element-110">No es casualidad.</p>
          <p className="mb-6 text-xl" data-id="element-111">Sabés que querés cambiar.</p>
          <p className="mb-10 text-xl text-gray-300" data-id="element-112">
            Pero también sabés que seguir como estás… no te está funcionando.
          </p>

          <p className="mb-2 text-2xl font-bold text-orange-400" data-id="element-113">
            La diferencia esta vez no es tu motivación.
          </p>
          <p className="mb-12 text-3xl font-black" data-id="element-114">Es el método.</p>

          <button onClick={scrollToCheckout} className="w-full md:w-auto bg-orange-500 hover:bg-orange-600 text-white font-bold py-4 px-8 rounded-full shadow-lg transform transition hover:-translate-y-1 inline-flex items-center justify-center gap-2 text-lg md:text-xl mb-12" data-id="element-115">
            👉 Empezá hoy con Running para la Vida Real
          </button>

          <p className="mb-4 text-xl text-gray-300" data-id="element-116">
            Y convertite en alguien que:
          </p>
          <p className="mb-2 text-2xl text-gray-400 line-through" data-id="element-117">
            No lo intenta…
          </p>
          <p className="text-5xl font-black text-white tracking-tight" data-id="element-118">
            LO SOSTIENE.
          </p>
        </div>
      </main>

      <SocialProofPopup data-id="element-119" />
    </div>;
}